import store from '@/store'
import utils from '@/libs/utils.js';
import {Message} from 'element-ui';
// 复制
const handlecopy = (mulerrIds) => {
    let copyTxt = (mulerrIds||'').split(',').join('\r\n');
    console.log('复制', copyTxt)
    utils.setClipboardText(copyTxt);
    Message({
        message: '复制成功',
        type: 'success'
    });
}
// 请求中 单个使用
export const get_flag_single_post_html = (id) => {
    let flag_html = `
    <div class="apple-dialog">
        <div class="apple-dialog-body">
            <div class="a_b_title">
                <i class="el-icon-success"></i>
                <h5>请求成功，正在处理…</h5>
            </div>
            <div class="a_b_body break-word" style="max-height: 300px;overflow-y: auto;padding-right: 10px;">
                <p style="color:#333">${id}，正在处理，请稍后</p>
            </div>
        </div>
    </div>`
    return flag_html
}

// 请求成功  单个多个公用
export const get_flag_suc_html = (info, msg) => {
    let flag_html = `
    <div class="apple-dialog">
        <div class="apple-dialog-body">
            <div class="a_b_title break-word" style="max-height: 200px;overflow-y: auto;padding-right: 10px;">
                <i class="el-icon-success"></i>
                <h5>${info}</h5>
            </div>
            <div class="a_b_body break-word" style="max-height: 300px;overflow-y: auto;padding-right: 10px;">
                <p style="color:#333;line-height: 1.2;">${msg}</p>
            </div>
        </div>
    </div>`
    return flag_html
}

// 请求失败  单个   修改异常mulErr    修改失败mulexc
export const get_flag_single_err_html = (info, msg, mulErr, mulexc, current_name) => {
    // let flag_err = mulErr ? `<p style="color:#333;line-height: 1.2;">${mulErr}</p>` : ''
    // let flag_exc = mulexc ? `<p style="color:#333;line-height: 1.2;">${mulexc}</p>` : ''
    let flag_err = mulErr&&mulErr.length>0 ? `${getMulErrText(mulErr)}` : ''
    let flag_exc = mulexc&&mulexc.length>0 ? `${getMulErrText(mulexc)}` : ''
    let flag_html = `
    <div class="apple-dialog">
        <div class="apple-dialog-body">
            <div class="a_b_title break-word" style="max-height: 200px;overflow-y: auto;padding-right: 10px;">
                <i class="el-icon-error"></i>
                <h5>${info}</h5>
            </div>
            <div class="a_b_body break-word" style="max-height: 300px;overflow-y: auto;padding-right: 10px;">
                <p style="color #333">${msg}</p>
                ${flag_err}
                ${flag_exc}
            </div>
            <div class="a_b_footer">
                <button style="padding: 0;" class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block " style="padding: 7px 15px;" data-apple-id=${current_name}_close>关闭</span></button>
            </div>
        </div>
    </div>`
    return flag_html
}

// 请求失败  多个   修改异常mulErr    修改失败mulexc
export const get_flag_mul_err_html = (info, msg, mulErr, mulexc, current_name, mulerrIds, setBtnText) => { 
    let flag_err = mulErr&&(mulErr.length>0) ? ` <p style="font-weight: bold;">修改失败:</p>${getMulErrText(mulErr)}` : ''
    let flag_exc = mulexc&&(mulexc.length>0) ? `<p style="font-weight: bold;">修改异常:</p>${getMulErrText(mulexc)}` : ''
    let flag_btn = ''
    
    if(!setBtnText) {
        if((mulErr && mulErr.length>0) && (mulexc && mulexc.length>0)) {
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制异常与失败的系列ID</span></button>`
        }else if((mulErr && mulErr.length>0) || (mulexc && mulexc.length>0)){
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制${mulErr.length>0 ?'失败':'异常'}的系列ID</span></button>`
        }else{
            flag_btn= ''
        }
    }else if(setBtnText == 'negative'){
        if((mulErr && mulErr.length>0) && (mulexc && mulexc.length>0)) {
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制异常与失败的否定关键词ID</span></button>`
        }else if((mulErr && mulErr.length>0) || (mulexc && mulexc.length>0)){
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制${mulErr.length>0 ?'失败':'异常'}的否定关键词ID</span></button>`
        }else{
            flag_btn= ''
        }
    }else if(setBtnText == 'keyword') {
        if((mulErr && mulErr.length>0) && (mulexc && mulexc.length>0)) {
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制异常与失败的关键词ID</span></button>`
        }else if((mulErr && mulErr.length>0) || (mulexc && mulexc.length>0)){
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制${mulErr.length>0 ?'失败':'异常'}的关键词ID</span></button>`
        }else{
            flag_btn= ''
        }
    }else{
        if((mulErr && mulErr.length>0) && (mulexc && mulexc.length>0)) {
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制异常与失败的否定关键词ID</span></button>`
        }else if((mulErr && mulErr.length>0) || (mulexc && mulexc.length>0)){
            flag_btn = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${mulerrIds}>复制${mulErr.length>0 ?'失败':'异常'}的否定关键词ID</span></button>`
        }else{
            flag_btn= ''
        }
    }


    let flag_html = `
    <div class="apple-dialog">
        <div class="apple-dialog-body">
            <div class="a_b_title break-word" style="max-height: 200px;overflow-y: auto;padding-right: 10px;">
                <i class="el-icon-error"></i>
                <h5>${info}</h5>
            </div>
            <div class="a_b_body break-word" style="max-height: 300px;overflow-y: auto;padding-right: 10px;">
                <p style="color:#333;line-height: 1.2;">${msg}</p>
                ${flag_err}
                ${flag_exc}
            </div>
            <div class="a_b_footer break-word">
                ${flag_btn}
                <button style="margin-left: 8px;padding: 0" class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name}_close>关闭</span></span></button>
            </div>
        </div>
    </div>`
    return flag_html
}


// 关键词、否定关键词提交
export const get_keyword_modal_err_html = (info, msg,errList,current_name) => {
    let errListStr = '';
    if(errList&&errList.length>0){
        errListStr = errList.map(item=>`<p class="break-word">${item}</p>`).join('');
    }


    let flag_html = `
    <div class="apple-dialog">
        <div class="apple-dialog-body">
            <div class="a_b_title break-word" style="max-height: 200px;overflow-y: auto;padding-right: 10px;">
                <i class="el-icon-error"></i>
                <h5>${info}</h5>
            </div>
            <div class="a_b_body break-word" style="max-height: 300px;overflow-y: auto;padding-right: 10px;">
                <p style="color:#333;line-height: 1.2;">${msg}</p>
                ${errListStr}
            </div>
            <div class="a_b_footer break-word">
                <button style="margin-left: 8px;padding: 0;" class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name}_close>关闭</span></span></button>
            </div>
        </div>
    </div>`
    return flag_html
}

export const handleDocumentNoctiyClick = (event) => {
    if (event.target.classList.contains('apple-dialog-btn—close')) {
        console.log('触发事件的元素包含 myClass 类', event.target);
        let dataIdValue = event.target.getAttribute('data-apple-id');   //存在即关闭
        let dataCopyValue = event.target.getAttribute('data-apple-copy');
        if(dataIdValue != null && dataCopyValue == null) {
            console.log('触发事件的元素包含 data-apple-id 属性，值为: ' + dataIdValue)  
            let removeCurrentNotify = store.getters.apple_notify[dataIdValue]
            if(removeCurrentNotify) {
                removeCurrentNotify.close()
            }
            setTimeout(() => {
                store.commit('apple/REMOVE_NOTIFY',dataIdValue)
            }, 0);
            // store.commit('apple/REMOVE_NOTIFY', 'id')
        }
        if(dataIdValue != null && dataCopyValue != null) {
            console.log('触发事件的元素包含 data-apple-copy 属性，值为: ' + dataCopyValue)
            handlecopy(dataCopyValue)
        }
    }
}

// 处理创建广告中的错误函数
export const get_create_ad_err_html = (info, msg='',errList,negativeErrList,current_name)=>{
    let errListStr = '';
    let negativeErrListStr = '';
    let errIds = [];
    let negativeErrIds = [];
    let errBtnStr = '';
    let negativeErrBtnStr = '';

    if(errList&&errList.length>0){
        errList.forEach(item=>{
            let ids = item.id||[];
            errIds = errIds.concat(ids);
        });
        errListStr = errList.map(item=>`<div class="mt10"><p>${(item.errMsg||[]).join(',')}</p></div>`).join('');
        errBtnStr = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${errIds.join(',')}>复制失败的关键词</span></button>`;
    }
    if(negativeErrList&&negativeErrList.length>0){
        negativeErrList.forEach(item=>{
            let ids = item.id||[];
            negativeErrIds = negativeErrIds.concat(ids);
        });
        negativeErrListStr = negativeErrList.map(item=>`<div class="mt10"><p>${(item.errMsg||[]).join(',')}</p></div>`).join('');
        negativeErrBtnStr = `<button style="padding: 0;" class="el-button el-button--primary is-plain el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name} data-apple-copy=${negativeErrIds.join(',')}>复制失败的否定关键词</span></button>`
    }

    let flag_html = `
    <div class="apple-dialog">
        <div class="apple-dialog-body">
            <div class="a_b_title break-word" style="max-height: 200px;overflow-y: auto;padding-right: 10px;">
                <i class="el-icon-error"></i>
                <h5>${info||'超时未响应：操作结果未返回，请人工登录媒体平台确认操作结果！也可尝试重试'}</h5>
            </div>
            <div class="a_b_body break-word" style="max-height: 300px;overflow-y: auto;padding-right: 10px;">
                <p style="color:#333;line-height: 1.2;">${msg||''}</p>
                ${errListStr}
                ${negativeErrListStr}
            </div>
            <div class="a_b_footer break-word">
                ${errBtnStr}
                ${negativeErrBtnStr}
                <button style="margin-left: 8px;padding: 0;" class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block" style="padding: 7px 15px;" data-apple-id=${current_name}_close>关闭</span></span></button>
            </div>
        </div>
    </div>`
    return flag_html;
};

// 处理错误函数
export const get_err_info = (err)=>{
    let errDataData = err;
    let errorInfo = errDataData['error'];
    let exceptionInfo = errDataData['exception'];
    console.log(errDataData, errorInfo, exceptionInfo)
    let errIds = [] //复制的ID
    let mulErr = []
    let mulexc = []

    if(errorInfo['id'] && errorInfo['id'].length != 0){
        errIds = errIds.concat(errorInfo.id);
    }
    if(exceptionInfo['id'] && exceptionInfo['id'].length != 0){
        errIds = errIds.concat(exceptionInfo.id);
    }

    if(errorInfo['errMsg'] && errorInfo['errMsg'].length != 0){
        mulErr = errorInfo['errMsg'];
    }
    if(exceptionInfo['errMsg'] && exceptionInfo['errMsg'].length != 0){
        mulexc = exceptionInfo['errMsg'];
    }
    return {errIds, mulErr, mulexc}
}

const getMulErrText = (mulErr) => {
    if(!Array.isArray(mulErr)||mulErr.length<=0) return '';
    return mulErr.map(item=>`<p style="color:#333;line-height: 1.2;margin-bottom: 6px;" class="font12px">${item}</p>`).join('');

};
